const interfacePhrases = {
    rate_limited: 'Frequência limitada',
    limit_exceeded: 'Limite excedido',
    used: 'Uso',
    identifier: 'Identificador',
    verification: 'Verificação',
    messages: 'Mensagens',
    data: 'Dados',
    custom: 'Personalizado',
    management_api: 'API de gerenciamento do {{product}}',
    management_api_role_description: 'Esta função integrada concede acesso à API de gerenciamento.',
    client_credentials: 'Credenciais do cliente',
    authentication_request: 'Solicitação de autenticação',
    callback: 'Retorno de autenticação',
    help_title: 'Central de ajuda iden',
    help_subtitle: 'Ajuda sem sair do seu espaço de trabalho',
    open_help: 'Abrir a página de ajuda completa',
    close_help: 'Fechar ajuda',
    about: 'Sobre e código aberto',
    open_navigation: 'Abrir navegação',
    close_navigation: 'Fechar navegação',
    development_enabled: 'Recursos de desenvolvimento ativados',
    beta: 'Beta',
    impersonation: 'Representação de usuário',
    key: 'Chave',
    value: 'Valor',
    error: 'Erro',
    details: 'Detalhes técnicos',
    callback_failed: 'Não foi possível concluir o retorno do login.',
    back_sign_in: 'Voltar ao login',
    powered_by: 'Desenvolvido por',
    avatar: 'Avatar',
    logo: 'Logotipo',
    qr_code: 'Código QR',
    sample_title: 'Quer ver um exemplo?',
    sample_description: 'Explore um aplicativo de exemplo que usa este guia.',
    sample_action: 'Ver exemplo',
    further_readings: 'Leituras complementares',
    complete_guide: 'Guia completo',
    custom_domains_notice: 'Após adicionar <a>domínios personalizados</a>, você pode usar este endpoint: <code>{{endpoint}}</code>.',
    my_project: 'Meu projeto',
    my_secret: 'Meu segredo',
    my_token: 'Meu token',
    role_example: 'Leitor',
    reset_retry: 'Redefinir a configuração e tentar novamente',
    open_dev_panel: 'Abrir painel do desenvolvedor',
    close_dev_panel: 'Fechar painel do desenvolvedor',
    configuration: 'Configuração',
    app_id: 'ID do aplicativo',
    extra_parameters: 'Parâmetros adicionais de login',
    prompt: 'Solicitação de autenticação',
    scope: 'Escopo',
    resource: 'Recurso',
    resources_space_delimited: 'Recursos (separados por espaços)',
    sign_out_to_apply: 'Saia para aplicar as alterações.',
    refresh_token_grant: 'Autorização com token de atualização',
    organization_id: 'ID da organização',
    console_result: 'Veja o resultado no console do navegador.',
    request_token: 'Solicitar token',
    user_info: 'Informações do usuário',
    get_id_token_claims: 'Obter declarações do token de identidade',
    fetch_user_info: 'Buscar informações do usuário',
    device_initializing: 'Inicializando autorização do dispositivo…',
    device_success: 'Você entrou no aplicativo de demonstração.',
    sign_in_information: 'Suas informações de login:',
    email: 'E-mail',
    username: 'Nome de usuário',
    user_id: 'ID do usuário',
    sign_out_demo: 'Sair da demonstração',
    device_expired: 'Código do dispositivo expirado',
    generic_error: 'Algo deu errado',
    device_expired_description: 'O código do dispositivo expirou. Tente novamente para obter um novo código.',
    sign_in_title: 'Entre na sua conta',
    scan_instruction: 'Leia o código QR ou abra este endereço em outro dispositivo:',
    one_time_code: 'Digite o código de uso único',
    token_info: 'Informações do token',
    get_access_token: 'Obter token de acesso',
    context_unavailable: 'Não foi possível carregar as informações da conta.',
    not_initialized: 'As informações da conta não foram inicializadas.',
    not_set: 'Não definido',
    configured: 'Configurado',
    password: 'Senha',
    phone: 'Número de telefone',
    search_help: 'Pesquisar ajuda',
    language: 'Idioma',
    menu: 'Menu',
    compatibility_notice: 'Compatibilidade: os nomes herdados de SDKs, pacotes, protocolos, componentes e cabeçalhos de solicitação do Logto permanecem inalterados.',
    source: 'Fonte',
    upstream_repository: 'Repositório de origem',
    current_fork: 'Repositório atual',
    license_notice: 'iden é baseado no Logto, software de código aberto licenciado sob a Mozilla Public License 2.0.',
    about_description: 'Informações do produto e atribuição de código aberto.',
    page_not_found: 'Página não encontrada',
    page_not_found_description: 'Esta página não está disponível. Volte à central de ajuda para continuar.',
    introduction: 'Introdução',
    quick_starts: 'Início rápido',
    integration: 'Integração',
    end_user_flows: 'Fluxos do usuário final',
    authorization: 'Autorização',
    user_management: 'Gerenciamento de usuários',
    security: 'Segurança',
    customization: 'Personalização',
    connectors: 'Conectores',
    organizations: 'Organizações',
    self_hosting: 'Hospedagem própria',
    continue: 'Continuar',
    loading: 'Carregando…',
    save: 'Salvar',
    saved: 'Salvo',
    try_again: 'Tentar novamente',
    client_id: 'ID do cliente',
    client_secret: 'Segredo do cliente',
    redirect_uri: 'URI de redirecionamento',
    status: 'Status',
    type: 'Tipo',
    permissions: 'Permissões',
    token_data: 'Dados do token',
    context_data: 'Dados de contexto',
    jwt_extra_claims: 'Declarações adicionais do token',
    action_result: 'Resultado da ação',
    social_account_already_linked: 'Esta conta social já está vinculada.',
};
export default Object.freeze(interfacePhrases);
